import { render, staticRenderFns } from "./RegistryDaySection.html?vue&type=template&id=68193ef2&external"
import script from "./RegistryDaySection.ts?vue&type=script&lang=ts&external"
export * from "./RegistryDaySection.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports